@if (!!value || showFieldAsEdit) {
  <div
    class="field"
    >
    <label class="upper">{{ displayName }}</label>
    @if (showFieldAsEdit) {
      <div>
        <input
          [(ngModel)]="numberValue"
          class="input is-small"
          type="text"
          [placeholder]="displayName"
          (change)="numberFieldChange($event)" />
      </div>
    } @else {
      <div class="is-readonly">{{ formattedValue }}</div>
    }
  </div>
}
